// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1D-wF","content":"Consent_content__3Sgnz","footer":"Consent_footer__APNeZ"};